// extracted by mini-css-extract-plugin
module.exports = {"container":"List-container-3FxcX","text":"List-text-JsnTD","label":"List-label-j-JC_","item":"List-item-HQW1n"};